import Form from 'react-bootstrap/Form';
import styled, { css } from 'styled-components';
import { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';

const ErrorMessage = styled.span`
  background: var(--white);
  bottom: -100%;
  box-shadow: 0 3px 5px rgb(91 110 127 / 15%);
  color: var(--bdo-red);
  display: flex;
  font-size: 1.4rem;
  gap: 1rem;
  left: 0;
  line-height: 2.4rem;
  margin-top: 0.8rem;
  padding: 0.5rem 1rem;
  width: fit-content;
  z-index: 1;
`;

const FormSelect = (props) => {
  const {
    options,
    onChangeFunction,
    selectId,
    label,
    selectedOption,
    placeholder,
    ...passThroughProps
  } = props;
  const [showLabel, setShowLabel] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const selectRef = useRef(null);

  const handleChange = (e) => {
    setErrorMessage('');
    onChangeFunction(e);
  };

  const checkInvalid = (e) => {
    e.preventDefault();
    const { validity } = e.currentTarget;

    if (validity.valid) return;

    setErrorMessage('Please select a value.');
  };

  useEffect(() => {
    setShowLabel(
      selectedOption !== null &&
        selectedOption !== undefined &&
        Object.keys(selectedOption).length !== 0
    );
  }, [selectedOption]);

  return (
    options.length > 0 && (
      <div>
        <FormSelectStyled isInvalid={!!errorMessage}>
          <label className={classNames({ 'animate-label': showLabel })} htmlFor={selectId}>
            {label}
          </label>
          <Form.Select
            aria-labelledby={`${selectId}-error`}
            ref={selectRef}
            id={selectId}
            onChange={handleChange}
            aria-label={label}
            value={selectedOption}
            onInvalid={checkInvalid}
            onInput={checkInvalid}
            onBlur={checkInvalid}
            {...passThroughProps}
          >
            {placeholder && (
              <option value="" disabled>
                {placeholder}
              </option>
            )}
            {options.map((option) => (
              <option value={option.value} key={option.value}>
                {option.name}
              </option>
            ))}
          </Form.Select>
          <span className="material-icons">arrow_drop_down</span>
        </FormSelectStyled>
        {errorMessage && (
          <ErrorMessage id={`${selectId}-error`} aria-live="polite">
            <span className="material-icons-outlined">warning</span>
            {errorMessage}
          </ErrorMessage>
        )}
      </div>
    )
  );
};

const FormSelectStyled = styled.div`
  position: relative;
  width: 100%;
  height: min-content;

  label {
    position: absolute;
    left: 1.6rem;
    opacity: 0;
    pointer-events: none;
    top: 50%;
    transform: translateY(-50%);
    transition: all 0.15s ease;

    &.animate-label {
      color: var(--charcoal-2);
      font-size: 1.2rem;
      line-height: 2rem;
      letter-spacing: 0.05rem;
      opacity: 1;
      transform: none;
      top: 0.4rem;

      & + select {
        padding-block: 2.4rem 0.8rem;
      }
    }
  }

  select {
    --border-color: var(--grey);
    ${(props) =>
      props.isInvalid &&
      css`
        --border-color: var(--bdo-red);
      `}

    appearance: none;
    border: 1px solid var(--border-color);
    padding-inline: 1.6rem 3.2rem;
    width: 100%;
    padding-block: 1.6rem;
    font-size: 1.6rem;
    line-height: 2.4rem;
    outline: none;

    &:focus {
      border: 1px solid var(--charcoal-2);
      border-radius: 0;
    }
  }

  .material-icons {
    pointer-events: none;
    position: absolute;
    right: 0.5rem;
    top: 50%;
    transform: translateY(-50%);
  }
`;

export default FormSelect;
